import React from 'react';
import { useIntl } from 'react-intl';
import Dialog from '@/components/dialogs/Dialog';
import { ATTACHMENT_VIEW } from '../constants';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const DownloadableDatafileConfirmationDialog = ({ theme }) => {
  const intl = useIntl();
  const state = Selectors.useDownloadableDatafileConfirmationDialog();
  const hide = Events.useHideDownloadableConfirmationDialog();
  const confirm = Events.useUpdateDatasetAttachmentMetadata(state);
  const saveArgs = { attachmentId: state.attachmentId, metadata: { viewing: ATTACHMENT_VIEW.downloadable.name } };
  const { isFolder } = state;

  return (
    <Dialog
      className="aridhia-downloadable-datafile-deletion-dialog"
      closeMessageId="actions.cancel"
      message={isFolder
        ? 'dataset.attachments.downloadable.folder.confirmation.message'
        : 'dataset.attachments.downloadable.datafile.confirmation.message'}
      messageIcon="warning circle"
      minimumDataEntryMet
      onClose={hide}
      onSave={() => confirm(saveArgs)}
      saveMessageId="actions.confirm"
      theme={theme}
      title={intl.formatMessage({ id: 'actions.confirm' })}
      warning
    />
  );
};

export default DownloadableDatafileConfirmationDialog;
